export default __webpack_public_path__ + "static/media/nomination.3658a7de.svg";